import { useState } from 'react';
import { Title, useNotify } from 'react-admin';
import { Card, CardContent, TextField, Button, Box, Typography } from '@mui/material';

const ChangePassword = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const notify = useNotify();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            notify('Die neuen Passwörter stimmen nicht überein', { type: 'error' });
            return;
        }

        if (newPassword.length < 10) {
            notify('Das Passwort muss mindestens 10 Zeichen lang sein', { type: 'error' });
            return;
        }

        setLoading(true);

        try {
            const token = localStorage.getItem('token');
            const ssoUrl = process.env.REACT_APP_SSO_URL || 'https://oa-sso.wsk.gmbh';
            const response = await fetch(`${ssoUrl}/api/change-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    currentPassword,
                    newPassword,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                notify('Passwort erfolgreich geändert', { type: 'success' });
                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
            } else {
                notify(data.error || 'Passwort konnte nicht geändert werden', { type: 'error' });
            }
        } catch (error) {
            notify('Ein Fehler ist aufgetreten', { type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card>
            <Title title="Passwort ändern" />
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Passwort ändern
                </Typography>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                    <TextField
                        label="Aktuelles Passwort"
                        type="password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        fullWidth
                        required
                        margin="normal"
                    />
                    <TextField
                        label="Neues Passwort"
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        fullWidth
                        required
                        margin="normal"
                        helperText="Mindestens 10 Zeichen"
                    />
                    <TextField
                        label="Neues Passwort bestätigen"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        fullWidth
                        required
                        margin="normal"
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={loading}
                        sx={{ mt: 2 }}
                    >
                        {loading ? 'Wird geändert...' : 'Passwort ändern'}
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default ChangePassword;
